<template>
  <div class="tuolele-main-box sort-management-detail">
    <div class="tuolele-main-search tuolele-main-search-item">
      <el-form :inline="true" :model="dailyListQuery" class="fn-clear">
        <el-form-item label="" class="fn-left">
          <el-input v-model="dailyListQuery.child_id" placeholder="学员ID" />
        </el-form-item>
        <el-form-item label="" class="fn-left">
          <Select key="11" :selected.sync="dailyListQuery.shop_id" :data="shopLists" clearable placeholder="请选择校区" />
        </el-form-item>
        <el-form-item label="" class="fn-left">
          <Select key="10" :selected.sync="dailyListQuery.grade_id" :data="gradeLists" clearable placeholder="请选择年级" />
        </el-form-item>

        <el-form-item class="fn-left">
          <el-date-picker v-model="dailyListQuery.time" style="margin-left: 5px;" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
        </el-form-item>

        <el-form-item label="" class="fn-left">
          <el-button type="primary" @click="fnGetReportLists()">查询</el-button>
        </el-form-item>
      </el-form>
      <div style="color:#f97559">注：请先选择店铺，点击照片看大图，有学员ID的情况下可以筛选时间区间，否则只能查看一天数据；超过7天家长无法再填写评价</div>

    </div>
    <div class="table">
      <el-table
        :data="tableData"
        border
        stripe
      >

        <el-table-column prop="child_id" label="学员ID" />
        <el-table-column prop="send_time" label="发送时间" />
        <el-table-column prop="sub_name" label="学员姓名" />
        <el-table-column prop="grade_name" label="年级" />
        <el-table-column prop="teacher_name" label="班主任" />
        <el-table-column prop="is_qualified_name" label="是否合格" />
        <el-table-column prop="score_tag" label="标签及内容" />
        <el-table-column label="家长评分">
          <template slot-scope="scope">
            <span>{{ getIsFeed(scope.row.feedback) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否已读">
          <template slot-scope="scope">
            <span>{{ scope.row.is_read == 1 ? '已读' : '未读' }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="status_name" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="fnOpenDetail(scope.row.id,scope.row.sub_name)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer pagination-footer">
        <div class="block">
          <el-pagination
            layout="prev, pager, next, slot, jumper"
            :current-page.sync="dailyListQuery.p"
            prev-text="上一页"
            next-text="下一页"
            :total="dailyListQuery.total"
            :page-size="dailyListQuery.limit"
            @current-change="fnGetReportLists()"
          >
            <div class="chax">
              {{ dailyListQuery.p }}/{{
                dailyListQuery.total > 0 ? Math.ceil(dailyListQuery.total / dailyListQuery.limit) : 1
              }}
            </div>
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :title="currentSub + '的日报'"
      :visible.sync="dialogVisible"
      width="400px"
    >
      <iframe
        :src="reportUrl"
        frameborder="0"
        width="376"
        height="667"
      />
    </el-dialog>
  </div>
</template>

<script>

var moment = require('moment')

const dailyListQueryDefault = {
  child_id: '',
  shop_id: '',
  grade_id: '',
  begin_time: '',
  end_time: '',
  time: '',
  p: 0,
  total: 0,
  limit: 20
}

import Select from '@/components/Select'
import commondata from '@/utils/commondata'

export default {
  name: 'FrianceLists',
  components: { Select },
  data() {
    return {
      tableData: [],
      gradeLists: commondata.GRADE_LISTS,
      shopLists: [],
      dailyListQuery: Object.assign({}, dailyListQueryDefault),
      dialogVisible: false,
      reportUrl: '',
      currentSub: ''
    }
  },
  watch: {
    'dailyListQuery.time': {
      handler: function(newVal) {
        if (newVal && newVal.length > 1) {
          this.dailyListQuery.begin_time = moment(newVal[0]).format('YYYY-MM-DD')
          this.dailyListQuery.end_time = moment(newVal[1]).format('YYYY-MM-DD')
        } else {
          this.dailyListQuery.begin_time = ''
          this.dailyListQuery.end_time = ''
        }
      }
    }
  },
  mounted() {
    this.fnGetSelectList()
    this.fnGetReportLists()
  },
  methods: {
    fnGetSelectList: function() {
      this.$http.getMyShopList().then(res => {
        this.shopLists = res.data
      })
    },
    fnGetReportLists() {
      this.$http.reportList(this.dailyListQuery).then(res => {
        this.tableData = res.data
      })
    },
    fnOpenDetail(id, sub_name) {
      const url = process.env.VUE_APP_TUOLELE_URL
      this.currentSub = sub_name
      this.reportUrl = `${url}/api.php/show/getDayReportDetails?id=${id}&admin=1`
      this.dialogVisible = true
    },
    getIsFeed(feed) {
      if (!feed) {
        return '无'
      }
      switch (feed) {
        case '6':
          return '满意'
        case '7':
          return '不满意'
        default:
          return feed
      }
    }

  }
}
</script>

<style lang="scss">
.sort-management-detail {
  .tuolele-main-search {
    padding-bottom: 20px;
  }
  .add-content-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    .add-content-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #333;
      opacity: 0.7;
    }
  }
  .add-content {
    width: 620px;
    background-color: #ffffff;
    box-shadow: 0px 6px 20px 0px rgba(148, 148, 148, 0.5);
    border-radius: 10px;
    .add-header {
      width: 100%;
      padding: 25px 30px;
      border-bottom: 1px solid #f5f5f5;
      .title {
        font-size: 22px;
        font-weight: normal;
        font-stretch: normal;
        color: #4c84ff;
      }
      .close {
        cursor: pointer;
        img {
          width: 18px;
          height: 18px;
        }
      }
    }
    .el-table tr th {
      background: #fff;
      color: #333;
    }
    .el-table td,
    .el-table th {
      border: 1px solid #ebebeb !important;
    }
  }
  .input1 {
    width: 211px;
    margin-right: 10px;
  }
  .add-content-main {
    display: flex;
    flex-direction: column;
    padding: 30px;
  }
  .add-content-table {
    margin: 20px auto;
  }
  .confirm-btn {
    margin: 50px 0 30px;
    .title {
      color: $color_black;
      margin-bottom: 10px;
      span {
        color: $color_blue;
      }
    }
  }
}
</style>
